module.exports = __webpack_public_path__ + "img/system-3-logo.33c09e37.svg";